/**
 * Provider Templates
 * Defines configuration templates for different authentication provider types
 */

import { Cloud as CloudIcon, Business as BusinessIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import type { ProviderTemplates } from '../types';

/**
 * Get provider templates with localized labels
 * @returns Provider template configuration for all supported auth providers
 */
export const useProviderTemplates = (): ProviderTemplates => {
  const { t } = useTranslation();

  return {
    local: {
      name: t('auth.providers.types.local.name'),
      description: t('auth.providers.types.local.description'),
      icon: <BusinessIcon />,
      fields: [],
    },
    entra: {
      name: t('auth.providers.types.entra.name'),
      description: t('auth.providers.types.entra.description'),
      icon: <CloudIcon />,
      fields: [
        {
          key: 'tenant_id',
          label: t('auth.providers.fields.tenantId'),
          type: 'text',
          required: true,
        },
        {
          key: 'client_id',
          label: t('auth.providers.fields.clientId'),
          type: 'text',
          required: true,
        },
        {
          key: 'client_secret',
          label: t('auth.providers.fields.clientSecret'),
          type: 'password',
          required: true,
        },
        {
          key: 'redirect_uri',
          label: t('auth.providers.fields.redirectUri'),
          type: 'text',
          required: true,
        },
        {
          key: 'sync_groups',
          label: t('auth.providers.fields.syncGroups'),
          type: 'boolean',
          required: false,
        },
        {
          key: 'group_claim',
          label: t('auth.providers.fields.groupClaim'),
          type: 'text',
          required: false,
        },
      ],
    },
  };
};
